import { combineReducers } from 'redux';

// Front
import Layout from 'store/layout/reducer';

// Global
import Modal from 'store/global/modal/reducer';

// Authentication
import ForgotPassword from 'store/auth/forgotPassword/reducer';
import Login from 'store/auth/login/reducer';
import Profile from 'store/auth/profile/reducer';
import Register from 'store/auth/register/reducer';
import ResetPassword from 'store/auth/resetPassword/reducer';

import Media from 'store/media/reducer';

import Address from 'store/address/reducer';
import Administrator from 'store/administrator/reducer';
import Banking from 'store/banking/reducer';
import Booking from 'store/booking/reducer';
import BookingReview from 'store/booking-review/reducer';
import EditLocation from 'store/edit-location/reducer';
import Location from 'store/location/reducer';
import Place from 'store/place/reducer';
import PlaceContacts from 'store/place-contacts/reducer';
import Promotion from 'store/promotion/reducer';
import Room from 'store/room/reducer';
import RoomPriceType from 'store/room-price-type/reducer';
import RoomStatusList from 'store/location/room/reducer';
import Setting from 'store/setting/reducer';
import UpdatePlaceOtaCredentials from 'store/update-place-ota-credentials/reducer';
import customer from 'store/customer/reducer';
import finance from 'store/finance/reducer';
import invoice from 'store/invoice/reducer';
import analytics from 'store/analytics/reducer';
import DiscoverCategory from 'store/discover-category/reducer';
import DiscoverProvince from 'store/discover-province/reducer';
import DiscoverPlace from 'store/discover-place/reducer';
import DiscoverReview from 'store/discover-review/reducer';
import DiscoveryLocation from 'store/discovery-loaction/reducer';
import Gift from 'store/gift/reducer';
import Market from 'store/market/reducer';
import Landmark from 'store/landmark/reducer';
import ManageAccount from 'store/manageAccount/reducer';
import ManageCoin from 'store/manageCoin/reducer';
import ManagerPromotion from 'store/manager-promotion/reducer';
import ManagerOperation from 'store/manager-operation/reducer';
import ManagerReview from 'store/manager-review/reducer';
import ManagerComplaint from 'store/manager-complaint/reducer';
import ManagerTcxhFeedback from 'store/manager-tcxh-feedback/reducer';
import Voucher from 'store/voucher/reducer';
import ExtranetNotification from 'store/extranet-notification/reducer';
import Chat from 'store/chat/reducer';
import Revenue from 'store/revenue/reducer';
import VatSetting from 'store/vat-setting/reducer';

const rootReducer = combineReducers({
  // Global
  Modal,

  // public
  Layout,

  ForgotPassword,
  Login,
  Profile,
  Register,
  ResetPassword,

  Media,

  Address,
  Administrator,
  Booking,
  BookingReview,
  EditLocation,
  Location,
  Place,
  PlaceContacts,
  Promotion,
  Room,
  RoomPriceType,
  RoomStatusList,
  Setting,
  UpdatePlaceOtaCredentials,

  customer,

  Banking,
  finance,
  invoice,
  analytics,

  DiscoverCategory,
  DiscoverProvince,
  DiscoverPlace,
  DiscoverReview,
  DiscoveryLocation,
  Gift,
  Market,
  Landmark,
  ManageAccount,
  ManageCoin,
  ManagerPromotion,
  ManagerOperation,
  ManagerReview,
  ManagerComplaint,
  ManagerTcxhFeedback,
  Voucher,
  ExtranetNotification,
  Chat,
  Revenue,
  VatSetting,
});

export default rootReducer;
